import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { DomainService } from './domain-service';

@Injectable({
    providedIn: 'root'
})

/**
 * Servicio de consultas de siniestros (Innova)
 * @author Inetum
 */
export class ClaimService {

    constructor(private http: HttpClient, private domainService: DomainService) {
    }

    /**
     * Listado paginado de las consultas de siniestros del usuario logado.
     *
     * @param pageOffset desplazamiento de página (0-based)
     * @param pageSize tamaño de página
     */
    list(pageOffset: number, pageSize: number): Promise<any> {
        let httpParams = new HttpParams();
        httpParams = httpParams.append('pageOffset', pageOffset.toString());
        httpParams = httpParams.append('pageSize', pageSize.toString());

        const url = this.domainService.backendUrlWithContext + '/claims/list';
        return this.http.get(url, { params: httpParams }).toPromise();
    }

    /**
     * Listado completo (sin paginar) de las consultas de siniestros del usuario logado.
     * Solicita una página lo bastante grande para traer todas las consultas.
     */
    listAll(): Promise<any> {
        return this.list(0, 1000);
    }
}
